import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function ChatInterface() {
  const { assistantId } = useParams();

  return (
    <Navigate
      to="/"
      replace
      state={{
        retiredRoute: "chat",
        assistantId: assistantId || null,
      }}
    />
  );
}
